import React, { useState } from 'react';
import Axios from 'axios';
import { servicios_grupogack_admon, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import { JsonProyectos } from '../../../Helpers/JsonToOneLevel';
import ModalService from '../../../ModalService/ModalService';
import FormProyectos from './FormProyectos';

const ModalAddProyectos = ({ openAdd, setOpenAdd, agregar, errorTable, nombreModulo }) => {
    
    const [error, setError] = useState(null);

    const cerrarModal = () => {
        setOpenAdd(false);
        setError(null);
    }
        
    const enviarProyecto = proyecto => {
        const info = proyecto;
        Axios.post( `${servicios_grupogack_admon}/presupuestal/`, info, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    const proyecto = JsonProyectos(res.data.dataResponse);
                    agregar(proyecto);
                    setOpenAdd(false);
                    break;
                default:
                    errorTable(registro_no_guardado);
                    break;
            }
        })
        .catch(error => errorTable(registro_no_guardado));
    }

    return (
        <ModalService title="Nuevo Proyecto" parentNode={nombreModulo}
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
            <div className="row">
                <div className="col-12">
                    <FormProyectos
                        enviarProyecto={enviarProyecto}
                        error={error}
                        setError={setError}
                        agregar={agregar}
                        errorTable={errorTable}
                        setOpenAddFirst={setOpenAdd}
                        idModulo={nombreModulo}
                    />
                </div>
            </div>
        </ModalService>
    );
}

export default ModalAddProyectos;